import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

// Options come from Company Information → Quote Options (owner-managed). A legacy value not in the
// list still shows so older quotes don't lose it.
export const PresetSelect = ({ value, onChange, options, placeholder = "Select", testid }) => {
  const list = value && !options.includes(value) ? [...options, value] : options;
  return (
    <Select value={value || undefined} onValueChange={onChange}>
      <SelectTrigger className="h-8 [&>span]:truncate" data-testid={testid}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>
        {list.map((o, i) => <SelectItem key={o} value={o} data-testid={`${testid}-opt-${i}`}>{o}</SelectItem>)}
      </SelectContent>
    </Select>
  );
};

export default PresetSelect;
